module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-tab-menu"
  }, [_c('span', {
    staticClass: "button el-icon-arrow-left"
  }), _vm._v(" "), _c('div', {
    ref: "main",
    staticClass: "el-tab-menu-wrap"
  }, _vm._l((_vm.data), function(tab) {
    return _c('tabMenuItem', {
      attrs: {
        "tab": tab,
        "active": _vm.activeIndex == tab.id
      }
    })
  })), _vm._v(" "), _c('span', {
    staticClass: "button el-icon-arrow-right"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ab00fb3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tab-menu/src/tab-menu.vue
// module id = 606
// module chunks = 0